<template>
  <VModal
      :title="user.phone ? 'ویرایش کاربر ' + (user.name ?? '') : 'ایجاد کاربر'"
      :show="show">

    <VAlert class="mt-4" type="danger" v-if="errors.length > 0">
      <div v-for="(error, index) in errors"
           :key="error" :class="{'font-bold' : index === 0}">
        {{ index !== 0 ? '- ' + error : error }}
      </div>
    </VAlert>

    <form @submit.prevent="submit" ref="form">
      <input type="hidden" name="_method" value="PUT" v-if="user.phone">

      <div class="mt-5">
        <label>نام کاربر</label>
        <VInput type="text" name="name" :value="user.name" placeholder="نام کاربر" class="mt-4" required/>
      </div>

      <div class="flex justify-between gap-x-4 mt-5">
        <div>
          <label>شماره همراه</label>
          <VInput type="tel" name="phone" :value="user.phone" placeholder="شماره همراه" class="mt-4" required/>
        </div>

        <div>
          <label>رمزعبور</label>
          <VInput type="password" name="password" :value="user.password" placeholder="رمزعبور" class="mt-4" :required="!user.phone"/>
        </div>
      </div>

      <div class="mt-5">
        <label>نقش</label>
        <select name="role_id" class="bg-dark-form rounded-lg w-full mt-4 p-3 ">
          <option value="" disabled>انتخاب نوع</option>
          <option v-for="role in roles"
                  :key="role.id"
                  :value="role.id"
                  :selected="user.role ? role.id === user.role.id : false">
            {{ role.name }}
          </option>
        </select>
      </div>

      <VButton type="submit" class="mt-10 w-full">ثبت</VButton>

      <VLoadingScreen :show="loading"/>
    </form>

  </VModal>
</template>

<script>
import VModal from "@/components/General/VModal";
import VInput from "@/components/General/VInput";
import VButton from "@/components/General/VButton";
import {createUser, getRoles, updateUser} from "@/API/API";
import VAlert from "@/components/General/VAlert";
import VLoadingScreen from "@/components/General/VLoadingScreen";

export default {
  name: "ModalUser",
  components: {VLoadingScreen, VAlert, VButton, VInput, VModal},
  props: {
    show: Boolean,
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      active: 1,
      loading: false,
      errors: [],
      roles: []
    }
  },
  async created() {
    this.roles = (await getRoles()).data
  },
  methods: {
    submit() {
      this.loading = true
      this.errors = []

      let user = new FormData(this.$refs.form)

      if (this.user.phone) {
        this.updateUser(user)
      } else {
        this.createUser(user)
      }
    },
    updateUser(user) {
      updateUser(this.user.id, user)
          .then(resp => {
            this.$emit('edited', resp.data)
          })
          .catch(err => {
            this.$helper.validationError(err, this.errors);
          })
          .finally(() => {
            this.loading = false
          })
    },
    createUser(user) {
      createUser(user)
          .then(resp => {
            this.$emit('created', resp.data)
          })
          .catch(err => {
            this.$helper.validationError(err, this.errors);
          })
          .finally(() => {
            this.loading = false
          })
    }
  }

}
</script>

<style scoped>

</style>